export default __webpack_public_path__ + "static/media/tv6.8bd8583a.jpeg";